import { AppSelectBox } from 'components';

function QuestionBankCategory({ value, handleChange, fieldErrors = {} }) {
  return (
    <AppSelectBox
      labelProps={{ label: 'Select question bank category' }}
      selectProps={{
        value,
        onChange: handleChange,
      }}
      fieldErrors={fieldErrors}
    >
      <option disabled value="">
        Choose
      </option>
      <option value="previous_year">Previous Year Solutions</option>
      <option value="ncert_solutions">NCERT Solutions</option>
      <option value="lab">Lab</option>
      <option value="previous_year_papers">Previous Year Papers</option>
      <option value="question_bank">Question bank</option>
      <option value="mock_test">Mock test</option>
    </AppSelectBox>
  );
}

QuestionBankCategory.defaultProps = {
  handleChange: () => {},
};

export default QuestionBankCategory;
